// extracted by mini-css-extract-plugin
export default {"row":"_1S_KJ"};